import {useEffect} from 'react';

export function useGlobalMouseMove(handler: (event: MouseEvent) => void): void {
  useEffect(() => {
    function handleMouseMove(event: MouseEvent): void {
      handler(event);
    }
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [handler]);
}

export function useGlobalMouseClick(handler: (event: MouseEvent) => void): void {
  useEffect(() => {
    function handleMouseClick(event: MouseEvent): void {
      handler(event);
    }
    window.addEventListener('click', handleMouseClick);
    return () => window.removeEventListener('click', handleMouseClick);
  }, [handler]);
}
